import React from 'react';
import './homeMenu'; // CSS برای استایل
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getpervStateTab } from '../../../redux/loansTab/loansTabSlice';

const CustomModal = ({ isOpen, onClose, position, countNotification, setState }: any) => {
    if (!isOpen) return null;
    const handleOverlayClick = (e: any) => {
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className='relative w-full max-w-[550px] h-[8.2svh]'>
                {/* <div className="modal-content" style={{ top: position.top, left: position.left }}> */}
                <div style={{ top: position.top, left: position.left, position: 'absolute' }}>
                    <div className={`tooltip tooltip-top `} style={{ textAlign: 'center' }} >
                        <span className='primaryColorLight-900' style={{
                            fontSize: '12.5px', top: ' 15px',
                            position: 'relative'
                        }}>
                            شما  <span className='primaryErrorColorLight font-bold' style={{ fontSize: '18px' }}> &nbsp;{countNotification}&nbsp;</span> اطلاعیه خوانده نشده دارید.
                        </span>
                        <Button
                            onClick={() => setState!('notifications')}
                            // type="submit"
                            style={{
                                color: '#fff', fontSize: '12.5px', marginTop: '20px', height: ' 23px',
                                width: '60px'
                            }}
                            className='bgPrimaryErrorColorLight font-bold'
                        >مشاهده</Button>

                        <div className={`tooltip-arrow tooltip-arrow-top `}>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;